import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { SettingsService } from '../../_services/settings.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent {
  public companyName$: Observable<string>;
  public companyLogo$: Observable<string>;

  constructor(private readonly settingsService: SettingsService) {
    this.companyName$ = this.settingsService.companyName;
    this.companyLogo$ = this.settingsService.companyLogo;
  }
}
